import { memo } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { User } from '@phosphor-icons/react';

const RELATIONSHIP_TYPES = [
  'colleague', 'manager', 'reports-to', 'referral', 'spouse', 'parent-company',
  'subsidiary', 'vendor', 'client', 'partner', 'other',
];

/**
 * RelationshipDialog — extracted from ContactCardPage so typing in the parent
 * form doesn't re-render this modal's JSX. Wrapped in memo.
 */
function RelationshipDialogInner({
  open,
  onOpenChange,
  relSearch,
  searchRelContacts,
  relSearchResults,
  setRelSearchResults,
  setRelSearch,
  relSelectedContact,
  setRelSelectedContact,
  relForm,
  setRelForm,
  onSave,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[400px] rounded-none border-[#999] p-0 gap-0" data-testid="rel-dialog">
        <DialogHeader className="px-4 pt-3 pb-2 bg-[#E0E0E0] border-b border-[#999]">
          <DialogTitle className="text-[13px] font-bold text-[#333]">Link Contact</DialogTitle>
        </DialogHeader>
        <div className="p-4 space-y-3">
          {relSelectedContact ? (
            <div className="flex items-center gap-2 p-2 bg-[#E8E8E8] border border-[#B0B0B0]">
              <User size={13} className="text-[#666]" />
              <span className="text-[12px] font-medium flex-1">
                {relSelectedContact.first_name} {relSelectedContact.last_name}
              </span>
              <button
                onClick={() => {
                  setRelSelectedContact(null);
                  setRelForm((f) => ({ ...f, to_contact_id: '' }));
                }}
                className="text-[11px] text-[#C0392B]"
              >
                Remove
              </button>
            </div>
          ) : (
            <div>
              <input
                value={relSearch}
                onChange={(e) => searchRelContacts(e.target.value)}
                placeholder="Search contact..."
                className="w-full h-[28px] px-2 text-[12px] border border-[#B0B0B0] focus:outline-none focus:border-[#0B5394]"
                data-testid="rel-search"
              />
              {relSearch && relSearch.length === 1 && (
                <p className="mt-1 text-[10px] text-[#888] italic" data-testid="rel-search-hint">Keep typing — searching after 2 characters.</p>
              )}
              {relSearch && relSearch.length >= 2 && relSearchResults.length === 0 && (
                <p className="mt-1 text-[10px] text-[#C0392B]" data-testid="rel-search-no-results">
                  No contacts match "{relSearch}".
                </p>
              )}
              {relSearchResults.length > 0 && (
                <div className="mt-1 border border-[#B0B0B0] bg-white max-h-28 overflow-y-auto">
                  {relSearchResults.map((c) => (
                    <button
                      key={c.contact_id}
                      data-testid={`rel-option-${c.contact_id}`}
                      onClick={() => {
                        setRelSelectedContact(c);
                        setRelForm((f) => ({ ...f, to_contact_id: c.contact_id }));
                        setRelSearchResults([]);
                        setRelSearch('');
                      }}
                      className="w-full text-left px-2 py-1 text-[12px] hover:bg-[#E8E8E8]"
                    >
                      {c.first_name} {c.last_name}{' '}
                      {c.company && <span className="text-[#999]">({c.company})</span>}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}
          <select
            value={relForm.relationship_type}
            onChange={(e) => setRelForm((f) => ({ ...f, relationship_type: e.target.value }))}
            className="w-full h-[28px] px-2 text-[12px] border border-[#B0B0B0]"
            data-testid="rel-type"
          >
            {RELATIONSHIP_TYPES.map((t) => (
              <option key={t} value={t}>
                {t.replace('-', ' ')}
              </option>
            ))}
          </select>
        </div>
        <div className="flex justify-end px-4 py-2 bg-[#E0E0E0] border-t border-[#999]">
          <button
            onClick={onSave}
            disabled={!relForm.to_contact_id}
            className="px-3 py-1 text-[11px] font-medium bg-[#0B5394] text-white hover:bg-[#073763] disabled:opacity-50"
            data-testid="save-rel-btn"
          >
            OK
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default memo(RelationshipDialogInner);
